import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';

export const DashboardsDisplayGridRowDataFragmentGql: DocumentNode = gql`
fragment DashboardsDisplayGridRowDataFragment on Dashboard {
  id
  name
  path
  workbook {
    vizportalUrlId
    name
    projectName
    projectVizportalUrlId
    owner {
      domain
      username
      name
    }
  }
}
`;
